module.exports = __webpack_public_path__ + "static/media/horsetackdatabase.12859029.png";